// extracted by mini-css-extract-plugin
module.exports = {"bcWrapper":"styles_bcWrapper__qBINl","navigation":"styles_navigation__nxQrK","item":"styles_item__DhTUD","itemActive":"styles_itemActive__SxfMX","arrow":"styles_arrow__fvNGp"};